import * as React from 'react'
import * as Styled from './Main.styles'

const Main = ({ children, type }) => (
  <Styled.Main type={type} data-type={type}>
    {children}
  </Styled.Main>
)

export default Main
